import { Link } from "react-router-dom";
import { MiaLogoMark } from "@/components/layout/Navbar";
import { ArrowLeft } from "lucide-react";

export default function MmpLayout({ children, showBack = true, showFooter = true }) {
  return (
    <div className="min-h-screen bg-[#0B0F1A] text-slate-100 antialiased">
      <header className="sticky top-0 z-30 bg-[#0B0F1A]/80 backdrop-blur border-b border-white/5">
        <div className="mia-container flex items-center justify-between py-4">
          <Link to="/careers" className="flex items-center gap-3 min-w-0">
            <div className="w-10 h-10 rounded-full bg-white flex items-center justify-center shrink-0">
              <MiaLogoMark className="w-8 h-8" />
            </div>
            <div className="leading-tight min-w-0">
              <div className="font-display font-black text-white text-[0.78rem] tracking-tight">MARINE INFRASTRUCTURE</div>
              <div className="text-[0.62rem] font-bold text-sky-400 tracking-[0.18em] uppercase">MMP Portal</div>
            </div>
          </Link>
          {showBack && (
            <Link to="/" className="text-xs sm:text-sm text-slate-400 hover:text-sky-400 inline-flex items-center gap-1.5" data-testid="mmp-back-main">
              <ArrowLeft className="w-4 h-4" /> Back to main site
            </Link>
          )}
        </div>
      </header>
      <main>{children}</main>
      {showFooter && (
        <footer className="border-t border-white/5 py-8 mt-16">
          <div className="mia-container flex flex-col sm:flex-row items-center justify-between gap-3 text-xs text-slate-500">
            <div>© {new Date().getFullYear()} Marine Infrastructure Africa. All rights reserved.</div>
            <Link to="/" className="hover:text-sky-400">Marine Infrastructure main site →</Link>
          </div>
        </footer>
      )}
    </div>
  );
}
